module.exports = "img/flags/NC.8482a61.png";